import type {FC} from 'react'
import {memo} from 'react'
import {Icon} from 'src/common/Icon'

interface AttributeItem {
  text: string | null
}

interface AttributesSectionProps {
  attributes: AttributeItem[]
}

export const AttributesSection: FC<AttributesSectionProps> = memo(({attributes}) => {
  if (!attributes || attributes.length === 0) {
    return null
  }

  return (
    <div className="flex items-center gap-2.5 md:gap-4">
      {attributes.map((attribute, index) => (
        <div key={index} className="flex items-center gap-2 md:gap-4">
          {/* Attribute Item */}
          <div className="flex items-center gap-0.5 md:gap-3">
            <p className="text-button-xs md:text-button">{attribute.text}</p>
            {/* Check Icon */}
            <div className="relative size-5">
              <div className="absolute inset-0 flex items-center justify-center rounded-full bg-[#001c10]">
                <Icon name="filled-check-v2" className="size-4 text-green-neon" />
              </div>
            </div>
          </div>

          {/* Separator */}
          {index < attributes.length - 1 && <div className="h-[17px] w-px bg-moss-white opacity-40" />}
        </div>
      ))}
    </div>
  )
})

AttributesSection.displayName = 'AttributesSection'
